export default __webpack_public_path__ + "static/0124-71e4492f6fb9d13b74e295404d899faa.png";